var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"An arrow pointing down"),React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M1.23663562,6.9999 L7.84092115,0.8659 C8.04345124,0.6779 8.0544801,0.3609 7.86598676,0.1589 C7.67749341,-0.0421 7.35966154,-0.0541 7.15713146,0.1339 L0.159817246,6.6339 C0.0575495787,6.7289 0.0004,6.8609 0.0004,6.9999 C0.0004,7.1389 0.0575495787,7.2709 0.159817246,7.3659 L7.15713146,13.8689 C7.254386,13.9589 7.37670615,14.0029 7.4990263,14.0029 C7.63337795,14.0029 7.76772959,13.9499 7.86598676,13.8439 C8.0544801,13.6419 8.04345124,13.3259 7.84092115,13.1379 L1.23663562,6.9999 Z","transform":"matrix(0 -1 -1 0 14 8)","key":1})]);
}

ArrowDown.defaultProps = {"width":"14","height":"8","viewBox":"0 0 14 8"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
